import React from 'react';
import { Alert, DrawerBody, Skeleton, SkeletonLine, Typography, } from '@one-thd/sui-atomic-components';
import { ChallengesContext, DrawerContext, InfoRewardsContext, } from '../../../../contexts';
import { rhAnalytics, rhDrawer } from '../../../../constants/RewardsHub';
import { removeFromUrlParams } from '../../../Utils';
import { rewardTileList } from './rewardTileList';
import { useIsMobile } from '../../../../hooks';
import { analyticsOverlay } from '../../../../utils/analytics';
import { ListDrawerHeader } from '../PerkDrawer/PerkListComponents';
export var RewardsListDrawer = function () {
    var _a = React.useContext(InfoRewardsContext), rewardList = _a.rewardList, isLoading = _a.isLoading, getPerksInfoRewardsData = _a.getPerksInfoRewardsData, hasError = _a.hasError, refreshRewards = _a.refreshRewards;
    var setDrawerOpen = React.useContext(DrawerContext).setDrawerOpen;
    var _b = React.useContext(ChallengesContext), isChallengeLoading = _b.isChallengeLoading, hasChallengeError = _b.hasChallengeError, getChallengesInfo = _b.getChallengesInfo;
    React.useEffect(function () {
        analyticsOverlay(rhAnalytics.offersAvailableDrawer);
    }, []);
    var isMobile = useIsMobile().isMobile;
    var handleClose = function () {
        removeFromUrlParams('drawerList');
        setDrawerOpen(false);
    };
    var RewardAndChallengeError = function () {
        return (React.createElement(Alert, { status: "error" },
            React.createElement("div", null,
                React.createElement(Typography, null, rhDrawer.PerkErrorMessage),
                React.createElement("div", { className: "sui-text-base" },
                    React.createElement("button", { type: "button", onClick: function () {
                            refreshRewards();
                            getPerksInfoRewardsData();
                            getChallengesInfo();
                        } },
                        React.createElement("u", null, "Refresh"))))));
    };
    var RewardListBody = function () {
        return (React.createElement("div", null, hasError && hasChallengeError ? (React.createElement(RewardAndChallengeError, null)) : (React.createElement("div", { className: "sui-flex sui-flex-col" }, rewardTileList(rewardList, true, isMobile)))));
    };
    var rewardCount = isChallengeLoading || isLoading ? '' : "(".concat(rewardList === null || rewardList === void 0 ? void 0 : rewardList.length, ")");
    return (React.createElement(React.Fragment, null,
        React.createElement(ListDrawerHeader, { title: "Rewards Available ".concat(rewardCount), handleClose: handleClose }),
        React.createElement(DrawerBody, null,
            React.createElement("div", { className: isMobile ? '' : 'sui-px-2 sui-pb-2' },
                React.createElement("div", { className: "sui-pb-5 sui-text-base" }, rhDrawer.RewardsListInfo),
                isChallengeLoading || isLoading ? (React.createElement(SlidesSkeleton, null)) : (React.createElement(RewardListBody, null))))));
};
var SlidesSkeleton = function () {
    return (React.createElement(Skeleton, { grow: true },
        React.createElement(SkeletonLine, { variant: "multi", numberOfLines: 9 })));
};
